module.exports = __webpack_public_path__ + "img/tmn.ed8e071e.svg";